const TitleModal = (props: any) => {
  let title = props.title ?? "";

  return (
    <h5 className="TitleModal" >{title}</h5 >
  )
}

export default TitleModal